import { ArrowRight } from "lucide-react";
import { useOrder } from "./OrderProvider";

// Reusable combo card — clicking opens the Order Online popup.
export const ComboCard = ({ c }) => {
  const openOrder = useOrder();
  return (
    <button
      type="button"
      onClick={openOrder}
      data-testid={`combo-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
      className="group text-left w-full bg-[#141414] rounded-2xl overflow-hidden border border-white/10 hover:border-[#ffd100]/50 transition-colors h-full flex flex-col cursor-pointer"
    >
      <div className="relative h-56 overflow-hidden">
        <img src={c.image} alt={c.name} loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
      </div>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-display text-2xl font-medium text-white">{c.name}</h3>
        <p className="text-neutral-400 text-base mt-2 leading-relaxed flex-1">{c.includes}</p>
        <div className="mt-4 pt-4 border-t border-white/10 flex items-center justify-between gap-3">
          {c.price ? (
            <span className="text-[#ffd100] font-bold text-2xl">{c.price}</span>
          ) : (
            <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
              <span className="text-[#ffd100] font-bold text-xl">Veg {c.priceVeg}</span>
              <span className="text-neutral-300 font-semibold text-lg">Non-Veg {c.priceNonVeg}</span>
            </div>
          )}
          <span className="flex items-center gap-1 text-[#ffd100] font-semibold text-sm whitespace-nowrap group-hover:gap-2 transition-all">
            Order <ArrowRight size={16} />
          </span>
        </div>
      </div>
    </button>
  );
};
